module.exports = __webpack_public_path__ + "static/media/graciliano-capa.97f13d85.png";